// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__4QwUw","containerItemsCenter":"Skeleton_containerItemsCenter__2qBei"};